module.exports = __webpack_public_path__ + "img/chofu_learn_off.9a520258.svg";